export default "__VITE_ASSET__beadaf62__"